<template>
  <div class="join_platform">
    <ul class="pub_nav">
      <li class="active">
        <a href="javascript:;">入驻平台</a>
      </li>
    </ul>
    <div class="content">
      <div class="module">
        <div style="padding:0 30px;">
          <div
            class="state succ"
            v-if="designer && designer.status==='IdentityCertifieStatussuccess'"
          >
            <i class="el-icon-success"></i>已通过设计师认证，部分可修改的信息会在菜单"设计师-个人主页"显示，其他信息不对外公开
          </div>
          <div
            class="state danger"
            v-if="designer && designer.status==='IdentityCertifieStatusReturned'"
          >
            <i class="el-icon-warning"></i>
            审核退回：{{designer.examine_remark}}
          </div>
          <div
            class="state danger"
            v-if="designer && designer.status==='IdentityCertifieStatusFailed'"
          >
            <i class="el-icon-warning"></i>
            审核不通过：{{designer.examine_remark}}
          </div>
          <div
            class="state danger"
            v-if="cantEditStatus && designer.status!=='IdentityCertifieStatusFailed'&& designer.status!=='IdentityCertifieStatussuccess'"
          >
            <i class="el-icon-warning"></i>正在审核中，请耐心等待
          </div>
        </div>
        <h3>基本信息</h3>
        <el-form :model="params" ref="myform">
          <el-form-item
            label="头像："
            :label-width="label_width"
            prop="head"
            :rules="[{ required: true, message: '请上传头像', trigger: 'blur' }]"
          >
            <div class="avater">
              <div class="avater_l">
                <uploadImg :params="params" :apiParams="apiParams" :disabled="cantEditStatus"></uploadImg>
              </div>
              <div class="avater_r">
                <p>1.请上传封面,文件格式为jpg,png,bmp,建议图片尺寸100*100</p>
                <p>2.用于巨景首页展示个人风采</p>
              </div>
            </div>
            <input type="hidden" v-model="params.head" />
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            prop="name"
            label="真实姓名："
            :rules="[{ required: true, message: '请输真实姓名', trigger: 'blur' }]"
          >
            <el-input
              class="input-width"
              v-model="params.name"
              :disabled="cantEditStatus || (designer && designer.status==='IdentityCertifieStatussuccess')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            label="用户昵称："
            :rules="[{ required: true, message: '请输用户昵称', trigger: 'blur' }]"
          >
            <el-input
              class="input-width"
              prop="nick_name"
              maxlength="25"
              show-word-limit
              v-model="params.nick_name"
              :disabled="cantEditStatus"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="性别："
            prop="sex"
            :label-width="label_width"
            :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
          >
            <el-radio-group
              v-model="params.sex"
              :disabled="cantEditStatus || (designer && designer.status==='IdentityCertifieStatussuccess')"
            >
              <el-radio label="SexMan">男</el-radio>
              <el-radio label="SexWoMan">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            prop="phone"
            label="手机号码："
            :rules="[{ required: true, message: '请填写手机号码', trigger: 'blur' }]"
          >
            <div>
              <el-input class="input-width" v-model="params.phone" disabled></el-input>
            </div>
            <changeMobile
              class="input-width"
              @receiveMobile="receiveMobile"
              v-if="!cantEditStatus && (designer && designer.status==='IdentityCertifieStatussuccess')"
            ></changeMobile>
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            prop="city"
            label="现居地："
            :rules="[{ required: true, message: '请选择现居地', trigger: 'blur' }]"
          >
            <provincialSelection
              :config="config"
              :provinceProp="'province'"
              :cityProp="'city'"
              :params="params"
            ></provincialSelection>
          </el-form-item>
          <el-form-item :label-width="label_width" label="设计年龄：">
            <el-input
              class="input-width"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model.number="params.working_age"
              :disabled="cantEditStatus"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            prop="profession"
            label="职业："
            :rules="[{ required: true, message: '请选择职业', trigger: 'blur' }]"
          >
            <el-select
              v-model="params.profession"
              placeholder="请选择"
              class="input-width"
              :disabled="cantEditStatus"
            >
              <el-option v-for="item in major" :key="item.id" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            prop="design_fields"
            label="设计领域："
            :rules="[{ required: true, message: '请选择设计领域', trigger: 'blur' }]"
          >
            <el-select
              multiple
              v-model="params.design_fields"
              placeholder="请选择"
              class="input-width"
              :disabled="cantEditStatus"
            >
              <el-option
                v-for="item in design_fields"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="QQ：" :label-width="label_width">
            <el-input
              class="input-width"
              placeholder="请输入QQ"
              v-model="params.qq"
              :disabled="cantEditStatus"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信：" :label-width="label_width">
            <el-input
              class="input-width"
              placeholder="请输入微信号"
              v-model="params.wechat"
              :disabled="cantEditStatus"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label-width="label_width"
            prop="synopsis"
            label="个人简介："
            :rules="[{ required: true, message: '请填写个人简介', trigger: 'blur' }]"
          >
            <el-input
              class="textarea-width"
              maxlength="200"
              show-word-limit
              rows="6"
              type="textarea"
              :disabled="cantEditStatus"
              v-model="params.synopsis"
              placeholder="请填写相关设计经历，比如职业经历，参与的项目，取得的成就、奖励等。"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="module">
        <h3>
          上传作品
          <span>至少上传3个作品</span>
        </h3>
        <div class="pro_list">
          <i style="color:#F56C6C">*</i>
          <upload_opus :params="uploadParams" :disabled="cantEditStatus"></upload_opus>
        </div>
      </div>
      <div>
        <!-- 未认证 未提交 -->
        <div
          class="btn"
          @click="submit('submit')"
          v-if="!designer || designer.status==='' || designer.status==='IdentityCertifieStatusNotSubmitted'"
        >提交审核</div>
        <!-- 退回 -->
        <div
          class="btn"
          @click="submit('edit')"
          v-else-if="designer.status==='IdentityCertifieStatusReturned'"
        >重新审核</div>
        <!-- 认证成功 -->
        <div
          class="btn"
          @click="submit('edit')"
          v-else-if="designer.status==='IdentityCertifieStatussuccess'"
        >修改</div>
        <!-- 审核中 -->
        <div class="btn disabled" v-else>提交审核</div>
      </div>
    </div>
  </div>
</template>

<script>
import changeMobile from "@/components/changeMobile/change_mobile";
import provincialSelection from "@/components/provincial_selection/provincial_selection.vue";
import upload_opus from "@/components/upload_opus/index.vue";
import uploadImg from "@/components/file_upload/uploadImg.vue";
export default {
  components: {
    changeMobile,
    provincialSelection,
    upload_opus,
    uploadImg
  },
  data() {
    return {
      params: {
        working_age: 0,
        province: "",
        city: "",
        phone: "",
        status: "IdentityCertifieStatusSubmitted" //提交
      },
      uploadParams: {
        img_list: [] //上传图片id接收列表
      },
      apiParams: {
        params: {
          catalog: "CatalogWhaleImage",
          is_public_read: true
        },
        imgPath: "headPath", //图片展示字段
        fileId: "head" //文件id字段
      },
      label_width: "120px",
      design_fields: [], //设计领域
      major: [], //职业
      config: {}
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    },
    cantEditStatus() {
      //true不可修改 false 可修改
      let designer = this.$store.state.designer || null;
      let state = designer ? this.$store.state.designer.status : "";
      let isTrue =
        state !== "" &&
        state !== "IdentityCertifieStatusNotSubmitted" &&
        state !== "IdentityCertifieStatusReturned" &&
        state !== "IdentityCertifieStatussuccess";
      this.config = {
        province: {
          disabled: isTrue
        },
        city: {
          disabled: isTrue
        }
      };
      return isTrue;
    }
  },
  created() {
    if (this.info) {
      this.setPhone();
    } else {
      this.needInfo("info", "setPhone");
    }
    if (this.designer) {
      this.initData();
    } else {
      this.needInfo("designer", "initData");
    }
    this.getDictionaries("DesignField", "design_fields"); //设计领域
    this.getDictionaries("DesignerProfession", "major"); //职业
  },
  methods: {
    /** 提交表单验证*/
    submit(type) {
      this.$refs["myform"].validate(valid => {
        if (valid) {
          if (this.uploadParams.img_list.length < 3) {
            this.$message.info("请至少上传3个作品");
            return;
          }
          type === "submit" && this.createFrontDesigner();
          type === "edit" && this.updateFrontDesigner();
        } else {
          this.$message.info("请检测必填项!");
          return false;
        }
      });
    },
    // 初始数据
    initData() {
      const {
        head,
        headPath,
        name,
        nick_name,
        sex,
        phone,
        city,
        province,
        working_age,
        profession,
        design_fields_id,
        qq,
        wechat,
        synopsis,
        image_details,
        image_detailsPath
      } = this.$store.state.designer;
      this.params = Object.assign({}, this.params, {
        head,
        headPath,
        name,
        nick_name,
        sex,
        phone,
        city,
        province,
        working_age,
        profession,
        design_fields_id,
        qq,
        wechat,
        synopsis
      });
      let img_list = image_detailsPath.split("|") || []; //作品数组
      let img_list_arr = []; //作品路径数组(组件渲染)
      let img_id = image_details.split(","); //作品id数组
      img_list.forEach((item, idx) => {
        img_list_arr.push({
          filePath: item,
          fileId: img_id[idx]
        });
      });
      this.uploadParams.img_list = img_list_arr; //作品展示
      this.params.design_fields = this.params.design_fields_id.split(",") || []; //设计领域
    },
    // 首次提交设计师认证资料
    createFrontDesigner() {
      let params = this.params;
      params.design_fields = params.design_fields.join(",");
      const image_details = this.uploadParams.img_list.map(item => {
        return item.fileId;
      });
      params.image_details = image_details.join(",");
      this.api.createFrontDesigner(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message.success("提交成功！");
        this.$parent.getFrontDesigners(); //父级方法获取设计师资料
        this.$router.push({
          name: "join",
          query: {
            code: res.obj.id
          }
        });
      });
    },
    // 编辑设计师资料
    updateFrontDesigner() {
      let params = this.params;
      params.design_fields = params.design_fields.join(",");
      const image_details = this.uploadParams.img_list.map(item => {
        return item.fileId;
      });
      params.image_details = image_details.join(",");
      params.code = this.$route.query.code;
      if (this.designer.status === "IdentityCertifieStatussuccess") {
        delete params.status;
      }
      this.api.updateFrontDesigner(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message.success("修改成功！");
        this.$parent.getFrontDesigners(); //父级方法获取设计师资料
      });
    },
    // 设置手机号
    setPhone() {
      this.params.phone = this.info.mobile;
    },
    needInfo(name, FnName) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[FnName]();
          watchAch(); //取消监听
        }
      });
    },
    //更换手机号（子组件传值）
    receiveMobile(obj) {
      this.params.phone = obj.mobile;
    },
    /** 获取字典数据 */
    getDictionaries(typeCode, key) {
      let params = {
        typeCode: typeCode,
        pageNo: 0,
        pageSize: 999
      };
      this.api.getDictionaries(params, true).then(res => {
        this[key] = res.obj.list;
      });
    }
  }
};
</script>

<style lang="scss">
.join_platform {
  .content {
    padding-top: 12px;
    h3 {
      line-height: 57px;
      height: 57px;
      font-size: 16px;
      color: $font-black;
      font-weight: bold;
      text-indent: 30px;
      span {
        font-size: 12px;
        color: $font-gary;
        font-weight: normal;
        margin-left: 28px;
      }
    }
    .module {
      background: #fff;
      padding: 10px 0;
      margin-bottom: 10px;
      width: 862px;
    }
    .module:last-child {
      margin: 0;
    }
    .pro_list {
      padding: 0 0 20px 46px;
      position: relative;
      & > i {
        position: absolute;
        top: 0;
        left: 30px;
      }
    }
    .btn {
      width: 90px;
      text-align: center;
      height: 34px;
      line-height: 34px;
      background: rgba(17, 17, 17, 1);
      border-radius: 2px;
      margin-top: 20px;
      color: #fff;
      cursor: pointer;
    }
    .btn.disabled {
      background: $font-gary;
      cursor: not-allowed;
    }
  }
  .avater {
    display: flex;
    .avater_l {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
    }
    .avater_r{
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-left: 20px;
      p{
        color: #999;
        font-size: 12px;
      }
    }
  }
  .state {
    background: #f5f5f5;
    line-height: 40px;
    padding: 0 20px;
    font-size: 13px;
    i {
      margin-right: 8px;
    }
  }
  .state.danger {
    color: #f93333;
  }
  .state.succ {
    color: #23d050;
  }
  .el-textarea .el-input__count {
    background: rgba(250, 250, 250, 0.3);
  }
}
</style>
